import { createTheme, ThemeProvider } from "@mui/material/styles";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { globalColors } from "../../../Utils/colors";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import './style.scss'

const getStandardTextFieldTheme = () =>
  createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "--TextField-brandBorderColor": "#E0E3E7",
            "--TextField-brandBorderHoverColor": "#B2BAC2",
            "--TextField-brandBorderFocusedColor": "#6F7E8C",
            "& label.Mui-focused": {
              color: "var(--TextField-brandBorderFocusedColor)",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "var(--TextField-brandBorderColor)",
          },
          root: {
            backgroundColor: globalColors.textBoxBackgroundGrey,
            borderRadius: "12px",
            color: globalColors.primary,
            fontFamily: "Poppins",
            fontSize: "14px",
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--TextField-brandBorderHoverColor)",
            },
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--TextField-brandBorderFocusedColor)",
            },
          },
        },
      },
    },
  });

export default function CustomizedDatePicker(props: any) {

  return (
    <ThemeProvider theme={getStandardTextFieldTheme()}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className='date-range-picker'
          slotProps={{ field: { clearable: true } }}
          {...props}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
